import numeral from "numeral";

export function formatWeight(number = 0, withFloat = false) {
    if (withFloat) {
        const calcArr = number.toString().match(/^-?\d+(?:\.\d{0,3})?/);
        if (calcArr) {

            return numeral(calcArr[0])
                .format(calcArr[0].includes(".") ? "0,0.000" : "0,0")
                .replace(/,/g, " ");
        } else {
            return "";
        }
    } else {
        return numeral(number).format("0,0").replace(/,/g, " ");
    }
}

export function formatNumber(num) {
    if (typeof num === "number") {
        return `0${num}`.slice(-2);
    }

    return NaN;
}

export function formattedDateTime(dateTime) {
    const date = new Date(dateTime);
    const dd = formatNumber(date.getDay() + 1);
    const mm = formatNumber(date.getMonth() + 1);
    const yy = date.getFullYear();
    const HH = formatNumber(date.getHours());
    const MM = formatNumber(date.getMinutes());
    const SS = formatNumber(date.getSeconds());

    return `${dd}-${mm}-${yy} ${HH}:${MM}:${SS}`;
}

export function formatPrice(incomeNumber, withFloat = false) {
    const number = incomeNumber || 0;
    if (withFloat) {
        const calc = number.toString();

        return numeral(calc)
            .format(calc.includes(".") ? "0,0.00" : "0,0")
            .replace(/,/g, " ");
    } else {
        return numeral(number).format("0,0").replace(/,/g, " ");
    }
}